import clsx from 'clsx'
import type { HTMLAttributes, TableHTMLAttributes, TdHTMLAttributes, ThHTMLAttributes } from 'react'

/** Äußerer Rahmen: horizontal scroll, Rahmen, Dark-tauglich. */
export function TableScrollArea({
  children,
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={clsx(
        'overflow-x-auto rounded-lg border border-gray-200 bg-white shadow-sm dark:border-gray-700 dark:bg-gray-900 dark:shadow-black/20',
        className
      )}
      {...props}
    >
      {children}
    </div>
  )
}

export function Table({ children, className, ...props }: TableHTMLAttributes<HTMLTableElement>) {
  return (
    <table
      className={clsx('min-w-full divide-y divide-gray-200 text-sm dark:divide-gray-700', className)}
      {...props}
    >
      {children}
    </table>
  )
}

export function TableHead({ children, className }: HTMLAttributes<HTMLTableSectionElement>) {
  return <thead className={clsx('bg-gray-50 dark:bg-gray-800/80', className)}>{children}</thead>
}

export function TableBody({ children, className }: HTMLAttributes<HTMLTableSectionElement>) {
  return (
    <tbody className={clsx('divide-y divide-gray-200 bg-white dark:divide-gray-700 dark:bg-gray-900', className)}>
      {children}
    </tbody>
  )
}

export function TableRow({ children, className, ...props }: HTMLAttributes<HTMLTableRowElement>) {
  return (
    <tr
      className={clsx('transition-colors hover:bg-gray-50 dark:hover:bg-gray-800/40', className)}
      {...props}
    >
      {children}
    </tr>
  )
}

export function TableHeaderCell({ children, className, scope = 'col', ...props }: ThHTMLAttributes<HTMLTableCellElement>) {
  return (
    <th
      scope={scope}
      className={clsx(
        'px-4 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500 dark:text-gray-400',
        className
      )}
      {...props}
    >
      {children}
    </th>
  )
}

export interface TableCellProps extends TdHTMLAttributes<HTMLTableCellElement> {
  align?: 'left' | 'right'
}

export function TableCell({ children, className, align = 'left', ...props }: TableCellProps) {
  return (
    <td
      className={clsx(
        'px-4 py-3 text-gray-900 dark:text-gray-100',
        align === 'right' && 'text-right tabular-nums',
        align === 'left' && 'text-left',
        className
      )}
      {...props}
    >
      {children}
    </td>
  )
}
